import { createFromProduct, ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import {
    createHandlerChainRunner,
    executeAwaitableHandlerChain,
    Handler,
} from "@insite/client-framework/HandlerCreator";
import {
    ConfigurationType,
    getProductById,
    GetProductByIdApiV2Parameter,
    GetProductVariantChildApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadProduct from "@insite/client-framework/Store/Data/Products/Handlers/LoadProduct";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import loadVariantChild from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChild";
import loadVariantChildren from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";
import {
    getProductState,
    getVariantChildrenDataView,
    hasEnoughInventory,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { OrderHistoryProductModel } from "@store/Types/ApiModels";

interface Parameter {
    selectedProduct?: OrderHistoryProductModel;
    searchTerm?: string;
}

interface Props {
    variantChildren?: ProductModel[] | null;
    selectedProduct?: OrderHistoryProductModel;
}

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginSetProduct: HandlerType = props => {
    const dispatch: any = props.dispatch;
    dispatch({
        type: "Components/OrderHistoryProductSelector/BeginSetOrderHistoryProduct",
    });
};

export const RequestDataFromApi: HandlerType = props => {
    const {
        parameter: { searchTerm, selectedProduct },
    } = props;
    if (!selectedProduct && !searchTerm) {
        return;
    }

    if (selectedProduct) {
        const initialSelectedProduct = selectedProduct;
        initialSelectedProduct.maxQtyOrdered = selectedProduct.qtyOrdered; // set initial Qty as maximum for RMA
        props.selectedProduct = initialSelectedProduct;
    }
};

export const DispatchUpdateOptions: HandlerType = props => {
    if (!props.selectedProduct) {
        return;
    }

    const dispatch: any = props.dispatch;
    dispatch({
        type: "Components/OrderHistoryProductSelector/UpdateOptions",
        result: props.selectedProduct,
    });
};

export const DispatchCompleteSetProduct: HandlerType = props => {
    const dispatch: any = props.dispatch;
    dispatch({
        type: "Components/OrderHistoryProductSelector/CompleteSetOrderHistoryProduct",
        selectedProduct: props.selectedProduct,
    });
};

export const chain = [DispatchBeginSetProduct, RequestDataFromApi, DispatchUpdateOptions, DispatchCompleteSetProduct];

const setProduct = createHandlerChainRunner(chain, "SetProduct");
export default setProduct;
